export const COMPANY_NAME_PROPS = {
  name: 'company.limited_company_info.company_name',
  label: 'Company Name',
  placeholder: 'Company name',
  autoCapitalize: 'on',
  autoCorrect: 'off',
};
